<p-dialog header="Header" [modal]="true" [(visible)]="productVisible" (onHide)="onDialogHide()" [style]="{width: '60vw'}">
    <ng-template pTemplate="header">
        <div class="d-flex align-items-center">
            <span class="icon-container-logo">
                <img alt="data-table-icon" src="../../../../../assets/images/svg/database-icon.svg"
                    style="width: 2rem" />
            </span>
            <div class="d-flex-d-column margin-left-5">

                <span class="user-title-text">{{dataTableview?.name}}</span>
                <span class="user-text-regular">Total No. of Event <span class="user-text-bold">({{dataTableview?.data?.length}})</span></span>
            </div>
        </div>
        <div></div>
        <div></div>
        <div>
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input type="text" pInputText class="search-input" placeholder="Search by name or ID" />
            </span>
        </div>
        <div></div>
        <div></div>
        <div class="">
            <p-button class="save-btn" label="Save" severity="secondary"></p-button>
        </div>
        <div>
            <p-button class="filter-btn" icon="pi pi-fw pi-filter"></p-button>
        </div>

        <div>
            <p-button class="filter-btn" icon="pi pi-ellipsis-h"></p-button>
        </div>
    </ng-template>
    <div class="products-data-table scroll-container">
        <p-table styleClass="custom-table"
                 [value]="dataTableview?.data"
                 [(selection)]="selectedProducts"
                 dataKey="code"
                 [paginator]="true"
                 [scrollable]="true"
                 [rows]="8"
                 [selectionPageOnly]="true"
                 [tableStyle]="{'min-width': '40rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th (click)="sortData(dataTableview, 'AuditType')" style="min-width:120px">Audit Type <i class="pi" [ngClass]="getSortIcon(dataTableview, 'AuditType')"></i></th>
                    <th (click)="sortData(dataTableview, 'AuditId')" style="min-width:120px">AuditID <i class="pi" [ngClass]="getSortIcon(dataTableview, 'AuditId')"></i></th>
                    <th (click)="sortData(dataTableview, 'ModifiedBy')" style="min-width:120px">Modified By <i class="pi" [ngClass]="getSortIcon(dataTableview, 'ModifiedBy')"></i></th>
                    <th (click)="sortData(dataTableview, 'ModifiedDate')" style="min-width:120px">Modified Date <i class="pi" [ngClass]="getSortIcon(dataTableview, 'ModifiedDate')"></i></th>
                    <ng-container *ngFor="let column of dataTableview.data[0]?.TableColumns">
                        <th style="min-width:200px" (click)="sortData(dataTableview, column.Name)">
                            {{ column.Name }}
                            <i class="pi" [ngClass]="getSortIcon(dataTableview, column.Name)"></i>
                        </th>
                    </ng-container>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-viewData>
                <tr>
                    <td>{{viewData.AuditType}}</td>
                    <td>{{viewData.AuditId}}</td>
                    <td> <span>{{viewData.ModifiedBy}}</span></td>
                    <td>{{viewData.ModifiedDate}}</td>
                    <td *ngFor="let tableColumn of viewData.TableColumns">{{tableColumn.Value}}</td>
                    
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-dialog>
